const initialState = {
  user: {},
  group: {},
  token: "",
  existedData: {},
  groupLoading: true,
};

export const AuthConstant = {
  SET_TRIGGER_AUTH: "AUTH_SET_TRIGGER_AUTH",
  SET_AUTH: "AUTH_SET_AUTH",
  SET_GROUP: "AUTH_SET_GROUP",
  CLEAR_AUTH: "AUTH_SET_CLEAR_AUTH",
  SET_EXISTED_DATA: "AUTH_SET_EXISTED_DATA",
  SET_GROUP_LOADING: "AUTH_SET_GROUP_LOADING",
};

export const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case AuthConstant.SET_GROUP_LOADING:
      return {
        ...state,
        groupLoading: action.bool,
      };
    case AuthConstant.SET_GROUP:
      return {
        ...state,
        group: action.item,
      };
    case AuthConstant.SET_EXISTED_DATA:
      return {
        ...state,
        existedData: {
          ...state.existedData,
          lastAvatar: {
            _id: action.item?._id,
            status: action.item?.status,
          }
        }
      }
    case AuthConstant.SET_TRIGGER_AUTH:
      if (action.item?._id === state.user?._id && action.item?.region === state.user?.region) {
        return state;
      } else {
        return {
          ...state,
          user: action.item,
          token: "",
        };
      }
    case AuthConstant.SET_AUTH:
      let token = "";
      try {
        token = `mario.${btoa(JSON.stringify(action.item))}.mario`;
      } catch (error) {
        console.log("ERROR[gen token]", error);
      }
      return {
        ...state,
        user: action.item,
        token: token,
      };
    case AuthConstant.CLEAR_AUTH: 
      return {
        ...state,
        user: {},
        group: {},
        token: "",
      };
    default:
      return state
  }
};
